import { FundingSource } from "@faire/retailer-visitor-shared/components/OpenWithFaire/OpenWithFaireApplication/FundingSource";
import Checkbox from "@faire/web--source/slate/Checkbox";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Span } from "@faire/web--source/slate/Typography";
import React, { FC, type JSX } from "react";
import styled from "styled-components";

export interface INestedCheckboxOption {
  key: FundingSource;
  label?: string;
  formattedText?: JSX.Element;
  children?: INestedCheckboxOption[];
}

interface IProps {
  options?: INestedCheckboxOption[];
  checkedFields: Record<FundingSource, boolean>;
  toggle: (key: FundingSource) => void;
  level?: number;
}

const INDENT_PER_LEVEL = getSpacing("4x");

export const NestedCheckboxes: FC<IProps> = ({
  options,
  checkedFields,
  toggle,
  ...props
}) => {
  const level = props.level ?? 0;

  if (!options || options.length === 0) {
    return null;
  }

  return (
    <IndentedColumn $indent={level === 0 ? "0" : INDENT_PER_LEVEL}>
      {options.map(({ key, label, children, formattedText }) => (
        <React.Fragment key={key}>
          <Spacer height="2x" />
          <Checkbox
            label={label}
            checked={checkedFields[key] ?? false}
            onChange={() => toggle(key)}
          >
            <Span>{formattedText}</Span>
          </Checkbox>
          {checkedFields[key] && children ? (
            <NestedCheckboxes
              options={children}
              level={level + 1}
              checkedFields={checkedFields}
              toggle={toggle}
            />
          ) : null}
        </React.Fragment>
      ))}
    </IndentedColumn>
  );
};

const IndentedColumn = styled(Column)<{ $indent: string }>`
  padding-left: ${({ $indent }) => $indent};
`;
